module.exports = __webpack_public_path__ + "img/yxlsycbg.d7212870.png";